var exports = {
  "kL": "GuildNotificationSettingsModal.module__container___d0czWW",
  "uW": "GuildNotificationSettingsModal.module__section___d0czWW",
  "Gf": "GuildNotificationSettingsModal.module__sectionTitle___d0czWW",
  "yV": "GuildNotificationSettingsModal.module__sectionDescription___d0czWW",
  "nv": "GuildNotificationSettingsModal.module__notificationSection___d0czWW",
  "RG": "GuildNotificationSettingsModal.module__suppressSection___d0czWW",
  "Sj": "GuildNotificationSettingsModal.module__mobilePushSection___d0czWW",
  "dY": "GuildNotificationSettingsModal.module__overridesSection___d0czWW",
  "dr": "GuildNotificationSettingsModal.module__overridesHeader___d0czWW",
  "bY": "GuildNotificationSettingsModal.module__overridesHeaderCell___d0czWW",
  "u1": "GuildNotificationSettingsModal.module__overridesHeaderCellLeft___d0czWW",
  "c": "GuildNotificationSettingsModal.module__overridesHeaderCellMute___d0czWW",
  "IC": "GuildNotificationSettingsModal.module__overrideItem___d0czWW",
  "sr": "GuildNotificationSettingsModal.module__overrideHeader___d0czWW",
  "yW": "GuildNotificationSettingsModal.module__channelInfo___d0czWW",
  "p": "GuildNotificationSettingsModal.module__channelIcon___d0czWW",
  "E8": "GuildNotificationSettingsModal.module__channelDetails___d0czWW",
  "HA": "GuildNotificationSettingsModal.module__channelName___d0czWW",
  "yb": "GuildNotificationSettingsModal.module__categoryName___d0czWW",
  "Z5": "GuildNotificationSettingsModal.module__mobileOverrideOptions___d0czWW",
  "Ue": "GuildNotificationSettingsModal.module__desktopNotificationOptions___d0czWW",
  "of": "GuildNotificationSettingsModal.module__checkboxCell___d0czWW",
  "DT": "GuildNotificationSettingsModal.module__removeButton___d0czWW",
  "kI": "GuildNotificationSettingsModal.module__iconTertiary___d0czWW",
};

module.exports = exports;
